import type {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage,
} from 'next';
import { Text } from 'src/presentation/components/atoms';
import { MainLayout } from 'src/presentation/layouts';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import styles from './misc-pages.module.scss';
import { settings } from '@config/settings';
import { MainRouter } from '@config/urls';
import { CountryLocationService } from '@services/country-location-service';
import { EntitiesFetcherService } from '@services/entities-fetcher';
import { localesParserDictionary } from '@utils/locales-parser';

const Home: NextPage = () => {
  const { t } = useTranslation();
  return (
    <MainLayout
      breadcrumb={[
        {
          label: t('urls.home'),
          url: MainRouter.home.generatePath(),
        },
        {
          label: t('urls.legal'),
          url: MainRouter.legal.generatePath(),
        },
      ]}
    >
      {/* <div className={styles.root}>
        <Text as="h2">{t("LegalView.title1")}</Text>
        <Text as="h3">{t("LegalView.title2")}</Text>
        <Text>{t("LegalView.p0")}</Text>
        <Text>{t("LegalView.p30")}</Text>
        <Text>{t("LegalView.p31")}</Text>
        <Text>{t("LegalView.p32")}</Text>
        <Text as="h3">{t("LegalView.title10")}</Text>
        <Text>{t("LegalView.p1")}</Text>
        <Text>{t("LegalView.p2")}</Text>
        <Text>{t("LegalView.p3")}</Text>
        <Text>{t("LegalView.p7")}</Text>
        <Text>{t("LegalView.p4")}</Text>
        <Text>{t("LegalView.p6")}</Text>
        <Text as="h3">{t("LegalView.title11")}</Text>
        <Text> - {t("LegalView.p33")}</Text>
        <Text> - {t("LegalView.p34")}</Text>
        <Text> - {t("LegalView.p35")}</Text>
        <Text> - {t("LegalView.p36")}</Text>
        <Text>{t("LegalView.p37")}</Text>
        <Text> - {t("LegalView.p38")}</Text>
        <Text> - {t("LegalView.p39")}</Text>
        <Text> - {t("LegalView.p40")}</Text>
        <Text>{t("LegalView.p41")}</Text>
        <Text>{t("LegalView.p42")}</Text>
        <Text>{t("LegalView.p43")}</Text>
        <Text>{t("LegalView.p44")}</Text>
        <Text>{t("LegalView.p45")}</Text>
        <Text>{t("LegalView.p46")}</Text>
        <Text>{t("LegalView.p47")}</Text>
        <Text>{t("LegalView.p48")}</Text>

        <Text as="h3">{t("LegalView.title12")}</Text>
        <Text>{t("LegalView.p49")}</Text>

        <Text as="h3">{t("LegalView.title13")}</Text>
        <Text>{t("LegalView.p50")}</Text>

        <Text as="h3">{t("LegalView.title14")}</Text>
        <Text>{t("LegalView.p51")}</Text>

        <Text as="h3">{t("LegalView.title15")}</Text>
        <Text>{t("LegalView.p52")}</Text>
        <Text>{t("LegalView.p53")}</Text>
        <Text> - {t("LegalView.p54")}</Text>
        <Text> - {t("LegalView.p55")}</Text>
        <Text>{t("LegalView.p56")}</Text>
        <Text>{t("LegalView.p57")}</Text>

        <Text as="h3">{t("LegalView.title16")}</Text>
        <Text>{t("LegalView.p58")}</Text>

        <Text as="h3">{t("LegalView.title17")}</Text>
        <Text>{t("LegalView.p59")}</Text>
        <Text>{t("LegalView.p60")}</Text>
        <Text>{t("LegalView.p61")}</Text>
        <Text>{t("LegalView.p62")}</Text>

        <Text as="h3">{t("LegalView.title18")}</Text>
        <Text>{t("LegalView.p63")}</Text>
        <Text>{t("LegalView.p64")}</Text>
        <Text>{t("LegalView.p65")}</Text>
        <Text>{t("LegalView.p66")}</Text>

        <Text as="h3">{t("LegalView.title19")}</Text>
        <Text>{t("LegalView.p67")}</Text>
        <Text>{t("LegalView.p68")}</Text>
        <Text>{t("LegalView.p69")}</Text>
        <Text>{t("LegalView.p70")}</Text>
        <Text>{t("LegalView.p71")}</Text>
        <Text>{t("View.p72")}</Text>

        <Text as="h3">{t("LegalView.title20")}</Text>
        <Text>{t("LegalView.p73")}</Text>

        <Text as="h3">{t("LegalView.title21")}</Text>
        <Text>{t("LegalView.p74")}</Text>
        <Text>{t("LegalView.p75")}</Text>
        <Text>{t("LegalView.p76")}</Text>
        <Text>{t("LegalView.p77")}</Text>
        <Text>{t("LegalView.p78")}</Text>

        <Text as="h3">{t("LegalView.title22")}</Text>
        <Text as="h2">{t("LegalView.title23")}</Text>
        <Text>{t("LegalView.p81")}</Text>
        <Text>{t("LegalView.p82")}</Text>
        <Text>{t("LegalView.p83")}</Text>
        <Text>{t("LegalView.p84")}</Text>
        <Text>{t("LegalView.p85")}</Text>
        <Text>{t("LegalView.p86")}</Text>
        <Text>{t("LegalView.p87")}</Text>
      </div> */}

      <div className={styles.root}>
        <Text as="h2">{t('LegalView.title1')}</Text>
        <Text as="h3">{t('LegalView.newTitular')}</Text>

        <Text>{t('LegalView.p1New')}</Text>
        <Text>{t('LegalView.p2New')}</Text>
        <Text>{t('LegalView.p3New')}</Text>
        <Text>{t('LegalView.p4New')}</Text>
        <Text>{t('LegalView.p5New')}</Text>
        <Text>{t('LegalView.p6New')}</Text>
        <Text>{t('LegalView.p7New')}</Text>
        <Text as="h3">{t('LegalView.newObjeto')}</Text>
        <Text>{t('LegalView.newObjetoP1')}</Text>
        <Text>{t('LegalView.newObjetoP2')}</Text>
        <Text>{t('LegalView.newObjetoP3')}</Text>
        <Text as="h3">{t('LegalView.newResponsabilidad')}</Text>
        <Text>{t('LegalView.newResponsabilidadP1')}</Text>
        <Text as="h3">{t('LegalView.newDirIP')}</Text>
        <Text>{t('LegalView.newDirIP1')}</Text>
        <Text>{t('LegalView.newDirIP2')}</Text>

        <Text as="h3">{t('LegalView.newPoliticaEnlaces')}</Text>
        <Text>{t('LegalView.newPoliticaEnlacesP1')}</Text>
        <Text>{t('LegalView.newPoliticaEnlacesP2')}</Text>
        <Text>{t('LegalView.newPoliticaEnlacesP3')}</Text>
        <Text as="h3">{t('LegalView.newPoliticaDatos')}</Text>
        <Text>{t('LegalView.newPoliticaDatosP1')}</Text>
        <Text>{t('LegalView.newPoliticaDatosP2')}</Text>

        <Text as="h3">{t('LegalView.newPropiedadIntelectualEindustrial')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP1')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP2')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP3')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP4')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP5')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP6')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP7')}</Text>
        <Text>{t('LegalView.newPropiedadIntelectualEindustrialP8')}</Text>

        <Text as="h3">{t('LegalView.newSSL')}</Text>
        <Text>{t('LegalView.newSSLP1')}</Text>
        <Text>{t('LegalView.newSSLP2')}</Text>
        <Text>{t('LegalView.newSSLP3')}</Text>
      </div>
    </MainLayout>
  );
};

export async function getServerSideProps(
  Props: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<any>> {
  const { locale, req, res } = Props;

  let selectedCountry =
    await new CountryLocationService().getSelectedCountryData(req, res);

  const opts = {
    locale: localesParserDictionary[locale || settings.DEFAULT_LANG],
    country: selectedCountry.countrycode,
  };

  const entities = await new EntitiesFetcherService().getEntities({
    ...opts,
    productosDestacados: true,
    productosGenericos: true,
  });

  return {
    props: {
      country: selectedCountry.countrycode,
      productosGenericos: JSON.stringify(entities.productosGenericosData),
      productosDestacadosData: JSON.stringify(entities.productosDestacadosData),
      ...(await serverSideTranslations(locale || settings.I18N_FALLBACK, [
        'common',
      ])),
    },
  };
}

export default Home;
